// assets/wow-cart-metafield-inject.js (robust + ajax listeners)
(function () {
  'use strict';
  if (!window || !document) return;
  var cache = {}; // handle -> description or null
  var lastRun = 0;

  function cssEscape(v) {
    return (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/([^\w-])/g, '\\$1');
  }

  function readFromDOM(handle) {
    if (!handle) return null;
    try {
      var el = document.querySelector('[data-short-description][data-product-handle="'+handle+'"], [data-short-description][data-handle="'+handle+'"]');
      if (el) return el.getAttribute('data-short-description') || null;

      var wrapper = document.querySelector('[data-product-handle="'+handle+'"],[data-handle="'+handle+'"]');
      if (wrapper) {
        var nested = wrapper.querySelector('[data-short-description]');
        if (nested) return nested.getAttribute('data-short-description') || null;
        var wd = wrapper.getAttribute('data-short-description');
        if (wd) return wd;
      }

      var link = document.querySelector('a[href*="/products/'+handle+'"]');
      if (link) {
        var ancestorWithAttr = link.closest('[data-short-description]');
        if (ancestorWithAttr) return ancestorWithAttr.getAttribute('data-short-description') || null;
        var wrapper2 = link.closest('.product-item, .card, .product-card, .product, [data-product-id], [data-json-product]');
        if (wrapper2) {
          var nested2 = wrapper2.querySelector('[data-short-description]');
          if (nested2) return nested2.getAttribute('data-short-description') || null;
          var wd2 = wrapper2.getAttribute('data-short-description');
          if (wd2) return wd2;
        }
        if (link.getAttribute('data-short-description')) return link.getAttribute('data-short-description');
      }
    } catch (e) { /* ignore */ }
    return null;
  }

  function fetchFromProductPage(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache.hasOwnProperty(handle)) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle))
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var meta = doc.querySelector('meta[name="product-short-description"][data-product-handle="'+handle+'"]') || doc.querySelector('meta[name="product-short-description"]');
          var val = meta ? meta.getAttribute('content') : null;
          cache[handle] = val;
          return val;
        } catch (e) { cache[handle] = null; return null; }
      }).catch(function () { cache[handle] = null; return null; });
  }

  function getShortDescription(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache.hasOwnProperty(handle)) return Promise.resolve(cache[handle]);
    var domVal = readFromDOM(handle);
    if (domVal !== null) {
      cache[handle] = domVal;
      return Promise.resolve(domVal);
    }
    return fetchFromProductPage(handle);
  }
function injectIntoCartItem(itemEl, text) {
  if (!itemEl || !text) return false;
  try {
    // already injected? bail out
    if (itemEl.getAttribute('data-metafield-injected') === '1' && itemEl.querySelector('.cart-item-metafield')) return false;

    // find the common blocks
    var info = itemEl.querySelector('.wow-cart-product-item__info-block') || itemEl.querySelector('.wow-cart-product-item__inner') || itemEl;
    var title = info.querySelector('.wow-cart-product-item__title, .wow-cart-product-item__title-container') || info.querySelector('a') || info;

    // Create the metafield element
    var p = document.createElement('p');
    p.className = 'cart-item-metafield';
    p.textContent = text;
    // keep inline styles for backward-compatibility; you can move these to CSS later
    p.style.margin = '6px 0 0';
    p.style.color = '#5c5c5c';
    p.style.fontSize = '13px';
    p.setAttribute('aria-hidden', 'false');

    // Preferred insertion: before the price block
    var priceSelectors = [
      '.wow-cart-product-item__price',
      '.wow-cart-product-price-block',
      '.ufe-cart-item-total-price',
      '.wow-cart-product__total-price',
      '.wow-cart-product-quantity_price'
    ];
    var priceNode = null;
    for (var i = 0; i < priceSelectors.length; i++) {
      var sel = priceSelectors[i];
      // look within the info block first, then the itemEl
      priceNode = info.querySelector(sel) || itemEl.querySelector(sel);
      if (priceNode) break;
    }

    if (priceNode && priceNode.parentNode) {
      // Insert BEFORE priceNode to appear above price
      priceNode.parentNode.insertBefore(p, priceNode);
    } else if (title && title.parentNode) {
      // fallback: insert after title (original behavior)
      title.parentNode.insertBefore(p, title.nextSibling);
    } else {
      // last fallback: append to item element
      itemEl.appendChild(p);
    }

    itemEl.setAttribute('data-metafield-injected', '1');
    console.log('wow-cart-metafield: injected for', itemEl.getAttribute('data-handle') || itemEl.getAttribute('data-product-handle'));
    return true;
  } catch (e) {
    console && console.warn && console.warn('inject error', e);
    return false;
  }
}


  function processCartItem(itemEl) {
    if (!itemEl) return;
    var handle = itemEl.getAttribute('data-handle') || itemEl.getAttribute('data-product-handle') || (itemEl.dataset && (itemEl.dataset.handle || itemEl.dataset.productHandle));
    if (!handle) return;
    if (itemEl.getAttribute('data-metafield-injected') === '1' && itemEl.querySelector('.cart-item-metafield')) return;
    getShortDescription(handle).then(function (desc) {
      if (desc) injectIntoCartItem(itemEl, desc);
    });
  }

  function processAll() {
    lastRun = Date.now();
    var items = document.querySelectorAll('.wow-cart-product-item, .wow-cart-product-item__wrapper .wow-cart-product-item, [data-handle].wow-cart-product-item, [data-product-handle].wow-cart-product-item');
    if (!items || items.length === 0) {
      items = document.querySelectorAll('.ufe-cart-item-original-price, .ufe-cart-item-total-price');
    }
    items.forEach(function (it) {
      var el = (it.getAttribute && (it.getAttribute('data-handle') || it.getAttribute('data-product-handle'))) ? it : (it.closest && it.closest('.wow-cart-product-item') ? it.closest('.wow-cart-product-item') : it);
      processCartItem(el);
    });
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        try { fn(); } catch (e) { console && console.warn && console.warn('debounced run error', e); }
      }, wait || 180);
    };
  }

  var observerCallback = debounce(function () {
    try {
      processAll();
    } catch (e) { console && console.warn && console.warn('processAll error', e); }
  }, 180);

  var mo = new MutationObserver(function (mutations) {
    var relevant = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.addedNodes && m.addedNodes.length) { relevant = true; break; }
      if (m.type === 'childList') { relevant = true; break; }
    }
    if (relevant) observerCallback();
  });

  mo.observe(document.body, { childList: true, subtree: true });

  function startPollingFallback(times, interval) {
    var i = 0;
    var id = setInterval(function () {
      processAll();
      i++;
      if (i >= times) clearInterval(id);
    }, interval || 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { processAll(); startPollingFallback(6, 600); }, { passive: true });
  } else {
    processAll();
    startPollingFallback(6, 600);
  }

  // --- AJAX add-to-cart helpers: trigger injector after add-to-cart actions ---
  (function(){
    // run injector (debounced small) safely
    var runInjector = function(delay){
      delay = typeof delay === 'number' ? delay : 450;
      try {
        setTimeout(function(){
          if (window.__wowCartMetafieldInjector && typeof window.__wowCartMetafieldInjector.run === 'function') {
            window.__wowCartMetafieldInjector.run();
          }
        }, delay);
      } catch(e){ console && console.warn && console.warn('runInjector error', e); }
    };

    // 1) Listen for clicks on ANY add-to-cart buttons or forms (delegated)
    document.addEventListener('click', function(e){
      try {
        var t = e.target;
        var btn = t.closest && t.closest('button, [type="submit"], a') || t;
        if (!btn) return;
        var isAddToCart = false;
        if (btn.matches && (btn.matches('[data-add-to-cart]') || btn.matches('.add-to-cart') || btn.matches('[name="add"]') || btn.matches('[aria-label*="Add to cart"]') || btn.matches('[type="submit"]') && btn.form && btn.form.querySelector('[name="id"]'))) {
          isAddToCart = true;
        }
        if (!isAddToCart) {
          var form = t.closest && t.closest('form');
          if (form && (form.matches('.add-to-cart-form') || form.querySelector('[name="id"]'))) isAddToCart = true;
        }
        if (isAddToCart) {
          runInjector(500);
        }
      } catch(e){}
    }, {capture:false, passive:true});

    // 2) Listen for form submit events (some themes use direct form submit)
    document.addEventListener('submit', function(e){
      try {
        var f = e.target;
        if (!f) return;
        if (f.querySelector && f.querySelector('input[name="id"], input[name="variant"], input[name="variant_id"]')) {
          runInjector(550);
        }
      } catch(e){}
    }, {capture:false, passive:true});

    // 3) Watch for fetch/XHR completions (generic) — re-run injector when network quiets
    (function(){
      if (window.fetch) {
        var _fetch = window.fetch;
        window.fetch = function(){
          var p = _fetch.apply(this, arguments);
          p.then(function(){ runInjector(350); }).catch(function(){ runInjector(350); });
          return p;
        };
      }
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function() {
        this._isTracked = true;
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function() {
        if (this._isTracked) {
          var xhr = this;
          var onEnd = function(){ runInjector(350); };
          xhr.addEventListener('load', onEnd, false);
          xhr.addEventListener('error', onEnd, false);
          xhr.addEventListener('abort', onEnd, false);
        }
        return origSend.apply(this, arguments);
      };
    })();

    // 4) If drawer open button exists, listen for it
    document.addEventListener('click', function(e){
      try {
        var t = e.target.closest && e.target.closest('.wow-cart-open, .wow-cart-toggle, .ufe-open-cart, .open-cart, .cart-toggle');
        if (t) runInjector(250);
      } catch(e){}
    }, {passive:true});
  })();

  // expose for debugging
  window.__wowCartMetafieldInjector = { run: processAll, cache: cache };
})();
